import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AuthResetPassword } from '@uturn/portal/modules/auth/pages/reset';
import z from 'zod';

export const ResetPasswordSearchSchema = z.object({
	token: z.string().optional(),
});

export const Route = createFileRoute('/_auth/reset-password')({
	validateSearch: zodValidator(ResetPasswordSearchSchema),
	component: AuthResetPassword,
});
